import { Actions } from './reclamationsActions';

import { Actions as CommonActions } from '../common/commonActions';
import { Actions as UtilisateurCourantActions } from '../utilisateur/courantActions';

import { ReclamationFiltre } from '../../constants';

import { dateToddmmyyy } from 'utils/stringHelper';

var lastMonth = new Date();
lastMonth.setMonth(lastMonth.getMonth() - 1);

/**
 * Etat initial
 *
 * */
const initialState = {
    items: [],
    isLoading: false,
    isPaging: false,
    isAdding: false,
    isPatching: false,
    isCloture: false,
    isCancelCloture: false,
    creation: {
        reclamationAjouteeId: 0,
        nextReclamation: null
    },
    recherche: {
        criteres: {
            page: 1,
            filtre: ReclamationFiltre.MaSelection,
            numeroPiece: '',
            typeId: 0,
            clientId: 0,
            dateCreationDebut: dateToddmmyyy(lastMonth),
            dateCreationFin: dateToddmmyyy(new Date()),
            statuts: [0, 1, 2],
            groupeId: 0,
            utilisateurId: 0,
            emetteurId: 0,
            codeArticle: '',
            codeArticleConcerne: false,
            transporteurId: 0,
            fournisseurCode: '',
            departement: '',
            motCle: '',
            utilisateurPreneurOrdreCodePO: '',
            codeAgence: '',
            groupesEmetteur: [],
            qualificationIds: []
        },
        didInvalidate: true
    },
    affectation: {
        reclamationId: 0,
        reclamation: null,
        groupe: {
            id: 0,
            libelle: ''
        },
        utilisateur: {
            id: 0,
            codePO: '',
            nom: '',
            prenom: ''
        },
        observateur: false,
        selfOnly: false,
        isLoading: false,
        adminOuPilote: false,
        picto: 0,
        warningMode: false
    },
    transporteurs:
    {
        items: [],
        isLoading: false
    },
    reclamationsMagasin:
    {
        items: [],
        isLoading: false,
        isGeneratingPackingList: false,
    }
};

//
// Reducer pour les reclamations
//
const reducer = (state = initialState, action) => {

    switch (action.type) {

        // Récupération de la liste des réclamations
        case Actions.FETCH_RECLAMATIONS_REQUEST:
            return {
                ...state,
                isLoading: state.recherche.criteres.page === 1 ? true : false,
                isPaging: state.recherche.criteres.page !== 1 ? true : false
            };
        case Actions.FETCH_RECLAMATIONS_SUCCESS:
            return {
                ...state,
                items: state.recherche.criteres.page === 1 ? [...action.reclamations] : [...state.items, ...action.reclamations],
                isLoading: state.recherche.criteres.page === 1 ? false : state.isLoading,
                isPaging: state.recherche.criteres.page !== 1 ? false : state.isPaging,
                recherche: {
                    ...state.recherche, didInvalidate: false, criteres: { ...state.recherche.criteres, page: action.reclamations.length > 0 ? state.recherche.criteres.page : state.recherche.criteres.page - 1 }
                }
            };
        case Actions.FETCH_RECLAMATIONS_FAILURE:
            return {
                ...state,
                error: action.error,
                isLoading: false,
                isPaging: false,
                recherche: { ...state.recherche, didInvalidate: false }
            };


        // Récupération de la liste des réclamations
        case Actions.FETCH_RECLAMATIONS_MAGASIN_REQUEST:
            return {
                ...state,
                reclamationsMagasin: {
                    ...state.reclamationsMagasin,
                    isLoading: true,
                }
            };
        case Actions.FETCH_RECLAMATIONS_MAGASIN_SUCCESS:
            return {
                ...state,
                reclamationsMagasin: {
                    ...state.reclamationsMagasin,
                    items: [...action.reclamations],
                    isLoading: false,
                }
            };
        case Actions.FETCH_RECLAMATIONS_MAGASIN__FAILURE:
            return {
                ...state,
                reclamationsMagasin: {
                    error: action.error,
                    isLoading: false,
                }
            };


        case Actions.INVALIDATE_RECHERCHE:
            return {
                ...state,
                //recherche: { ...state.recherche, didInvalidate: true }
                recherche: {
                    ...state.recherche,
                    didInvalidate: true,
                    criteres: {
                        ...state.recherche.criteres,
                        page: 1
                    }
                }
            };

        // CRITERES DE RECHERCHE
        case Actions.UPDATE_RECHERCHE_CRITERES:
            return {
                ...state,
                recherche: { criteres: { ...initialState.recherche.criteres, ...action.criteres }, didInvalidate: true }
            };
        case Actions.RESET_RECHERCHE_CRITERES:
            return {
                ...state,
                recherche: { criteres: { ...initialState.recherche.criteres, filtre: state.recherche.criteres.filtre }, didInvalidate: true }
            };
        case Actions.SET_RECHERCHE_CRITERE_FILTRE:
            return {
                ...state,
                recherche: { ...state.recherche, criteres: { ...state.recherche.criteres, filtre: action.filtre, page: 1 } }
            };
        case Actions.SET_RECHERCHE_CRITERE_CODE_DEPOT:
            return {
                ...state,
                recherche: { ...state.recherche, criteres: { ...state.recherche.criteres, codeDepot: action.codeDepot, page: 1 } }
            };
        case Actions.SET_RECHERCHE_CRITERE_CODE_AGENCE:
            return {
                ...state,
                recherche: { ...state.recherche, criteres: { ...state.recherche.criteres, codeAgence: action.codeAgence, page: 1 } }
            };

        // INIT_ADD_RECLAMATION
        case Actions.INIT_ADD_RECLAMATION:
            return {
                ...state,
                creation: { ...state.creation, reclamationAjouteeId: 0, nextReclamation: null }
            };

        // ADD_RECLAMATION...
        case Actions.ADD_RECLAMATION_REQUEST:
            return {
                ...state,
                isAdding: true
            };
        case Actions.ADD_RECLAMATION_SUCCESS:
            return {
                ...state,
                isAdding: false,
                creation: { ...state.creation, reclamationAjouteeId: action.reclamationId, nextReclamation: null }
            };
        case Actions.ADD_RECLAMATION_FAILURE:
            return {
                ...state,
                isAdding: false,
                creation: { ...state.creation }
            };
        case Actions.NEXT_RECLAMATION:
            return {
                ...state,
                creation: { ...state.creation, nextReclamation: action.reclamation }
            };

        // CLOTURER_...
        case Actions.CLOTURER_REQUEST:
            return {
                ...state,
                isCloture: true
            };
        case Actions.CLOTURER_SUCCESS:
            return {
                ...state,
                isCloture: false
            };
        case Actions.CLOTURER_FAILURE:
            return {
                ...state,
                isCloture: false
            };

        // ANNULER_CLOTURE_...
        case Actions.ANNULER_CLOTURE_REQUEST:
            return {
                ...state,
                isCancelCloture: true
            };
        case Actions.ANNULER_CLOTURE_SUCCESS:
            return {
                ...state,
                isCancelCloture: false
            };
        case Actions.ANNULER_CLOTURE_FAILURE:
            return {
                ...state,
                isCancelCloture: false
            };

        // Gestion de l'affectation
        case CommonActions.OPEN_AFFECTATION_DIALOG:
            return {
                ...state,
                affectation: { ...state.affectation, reclamationId: action.reclamationId }
            };
        case Actions.AFFECTATION_CHANGE_GROUPE:
            return {
                ...state,
                affectation: { ...state.affectation, groupe: action.groupe }
            };
        case Actions.AFFECTATION_CHANGE_UTILISATEUR:
            return {
                ...state,
                affectation: { ...state.affectation, utilisateur: action.utilisateur }
            };
        case Actions.AFFECTATION_CHANGE_OBSERVER:
            return {
                ...state,
                affectation: { ...state.affectation, observateur: action.observateur }
            };

        // Gestion de la requête d'affectation
        case Actions.AFFECTATION_REQUEST:
            return {
                ...state,
                isPatching: true
            };
        case Actions.AFFECTATION_SUCCESS:
            {
                return {
                    ...state,
                    isPatching: false,
                    affectation: { ...initialState.affectation },
                    items: state.items.map(x => x.id === action.data.reclamation.id ? {
                        ...x,
                        changeCount: x.changeCount === undefined ? 1 : x.changeCount + 1,
                        utilisateur: action.data.reclamation.utilisateur,
                        groupe: action.data.reclamation.groupe,
                        observateur: action.data.observateur,

                        adminOuPilote: action.data.adminOuPilote,
                        selfOnly: action.data.selfOnly,
                        picto: action.data.picto

                    } : x)
                };
            }
        case Actions.AFFECTATION_FAILURE:
            return {
                ...state,
                error: action.error,
                isPatching: false,
                affectation: { ...initialState.affectation }
            };

        // Gestion de la requête pour obtenir les informations pour l'affectation
        case Actions.FETCH_AFFECTATION_REQUEST:
            return {
                ...state,
                affectation: { ...state.affectation, isLoading: true }
            };
        case Actions.FETCH_AFFECTATION_SUCCESS:
            {
                let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

                return {
                    ...state,
                    affectation: {
                        ...state.affectation,
                        ...action.affectation,
                        groupe: { ...action.affectation.reclamation.groupe },
                        //utilisateur: { ...action.affectation.reclamation.utilisateur },
                        //groupe: !action.affectation.selfOnly && !action.affectation.adminOuPilote ? { id: 0 } : { ...action.affectation.reclamation.groupe },
                        utilisateur:
                            action.affectation.selfOnly ? { ...utilisateurCourant } :
                                action.affectation.adminOuPilote ? { ...action.affectation.reclamation.utilisateur } :
                                    { id: 0 },
                        isLoading: false
                    }
                };
            }

        case Actions.FETCH_AFFECTATION_FAILURE:
            return {
                ...state,
                affectation: { ...state.affectation, isLoading: false, error: action.error }
            };
            
        case Actions.AFFECTATION_WARNING:
            {                
                return {
                    ...state,
                    isPatching: false,
                    affectation: {
                        ...state.affectation,
                        ...action.affectation,
                        isLoading: false,
                        warningMode: true
                    },
                    items: state.items.map(x => x.id === action.affectation.reclamation.id ? {
                        ...x,
                        changeCount: x.changeCount === undefined ? 1 : x.changeCount + 1,
                        utilisateur: action.affectation.reclamation.utilisateur,
                        groupe: action.affectation.reclamation.groupe,
                        observateur: action.affectation.observateur,

                        adminOuPilote: action.affectation.adminOuPilote,
                        selfOnly: action.affectation.selfOnly,
                        picto: action.affectation.picto

                    } : x)
                };
            }



        // Récupération des transporteurs
        case Actions.FETCH_RECLAMATION_TRANSPORTEUR_REQUEST:
            return {
                ...state,
                transporteurs: { ...state.transporteurs, isLoading: true }
            };
        case Actions.FETCH_RECLAMATION_TRANSPORTEUR_SUCCESS:
            if (action.transporteur) {
                return {
                    ...state,
                    transporteurs: {
                        items: [...state.transporteurs.items, action.transporteur],
                        isLoading: false
                    }
                };
            }
            break;
        case Actions.FETCH_RECLAMATION_TRANSPORTEUR_FAILURE:
            return {
                ...state,
                error: action.error,
                transporteurs: { ...state.transporteurs, isLoading: false }
            };


        case Actions.GENERATE_PACKING_LIST_REQUEST:
            return {
                ...state,
                reclamationsMagasin: {
                    ...state.reclamationsMagasin,
                    isGeneratingPackingList: true
                }
            };
        case Actions.GENERATE_PACKING_LIST_SUCCESS:
            return {
                ...state,
                reclamationsMagasin: {
                    ...state.reclamationsMagasin,
                    isGeneratingPackingList: false,
                    items: []
                }
            };
        case Actions.GENERATE_PACKING_LIST_FAILURE:
            return {
                ...state,
                reclamationsMagasin: {
                    ...state.reclamationsMagasin,
                    isGeneratingPackingList: false,
                    error: action.error
                }
            };


        case Actions.TOGGLE_SUR_RETOUR_PALETTE_SUCCESS:

            console.log(action.data);

            return {
                ...state,
                reclamationsMagasin: {
                    ...state.reclamationsMagasin,
                    items: state.reclamationsMagasin.items.map(x => x.id === action.data.id ? {
                        ...x,
                        surPaletteRetour: action.data.surPaletteRetour
                    } : x),
                    error: action.error
                }
            };


        case UtilisateurCourantActions.LOGOUT:
            return { ...initialState };

        default: return { ...state };
    }
};

export default reducer;